import styled from 'styled-components';

export const Timer = styled.div`
	font-size: 2rem;
	font-weight: 600;
`
